import React, { Component } from 'react'
import _ from 'lodash'

import { Get } from 'utils/axios'
import { convertObjToBase64 } from 'utils/objToBase64'

const HOC = ( WrappedComponent ) => {
  class WithHOC extends Component {
    state = {
      loading: false,
      modules: {
        data: [],
        meta: {}
      }
    }

    load = param => this.setState({ loading: param })
    requestError = error => this.setState({
      showStatusModal: true,
      statusModalType: 'negative',
      onClickStatusModalButton: () => this.setState({ showStatusModal: false }),
      statusModalMessage: error
    })
    requestSuccess = success => this.setState({
      showStatusModal: true,
      statusModalType: 'positive',
      onClickStatusModalButton: () => this.setState({
        showStatusModal: false,
        errorMessage: {}
      }),
      statusModalMessage: success
    })

    getModules = ( tmp ) => Get(
      `/api/v1/modules?query=${ convertObjToBase64({ is_paginated: false, filter: {
        $or: [
          { status: 'ACTIVE' }
        ]
      } }) }`,
      this.getModulesSuccess,
      this.getModulesError,
      this.load
    )
    getModulesSuccess = payload => this.setState({ modules: payload })
    getModulesError = error => this.requestError( error )
    
    render = () => {
      return (
        <WrappedComponent 
          { ...this.props }
          onLoadModules={ this.state.loading }
          modules={ this.state.modules }
          getModules={ this.getModules } />
      )
    }
  }
  return WithHOC
}

export default HOC 